<template>
    <div>
        <a-modal :title="title" :visible='sureVisible' :width="1470" @ok="handleOk" @cancel="handleCancel">
            <template slot="footer">
                <a-button @click="handleCancel">关闭</a-button>
            </template>
            <div>
                <a-table ref="table" size="middle" bordered
                    :columns="columns" :dataSource="dataSource" :components="handleDrag(columns)" :pagination="ipagination" :loading="loading"
                    @change="handleTableChange" style="word-break: break-all;">
                    <!-- <span slot="action" slot-scope="text, record">
                        <a type="primary" @click="handleDelete(record)">删除</a>
                    </span> -->
                </a-table>
            </div>
        </a-modal>
    </div>
</template>
<script>
import { getOutProductList } from '@/api/api'
import { campListMixins } from '../mixins/campListMixins'

export default {
    name: 'outProduct',
    mixins: [campListMixins],
    data() {
      return {
        title: '出库统计',
        sureVisible:false,
        ipagination: {
            pageSize: 10, // 每页显示的条数
            showSizeChanger: true, // 是否可以改变每页显示的条数
            pageSizeOptions: ['10', '20', '30', '40'], // 可选的每页显示条数
            showQuickJumper: true, // 是否可以快速跳转到指定页
            showTotal: total => `共 ${total} 条`, // 显示总条数和当前数据范围
            current: 1, // 当前页数
            total: 50, // 总条数
        },
        searchId:'',
        // 查询条件
        queryParam: {
            validCode: ''
        },
        labelCol: {
            span: 5,
        },
        wrapperCol: {
            span: 18,
            offset: 1,
        },
        dataSourceCode: [],
        columns: [
          { title: '序号', dataIndex: 'index', width: 50, customRender:(text,record,index) =>`${index + 1}`},
          { title: '出库方', dataIndex: 'outPartyName', width: 80, ellipsis: true, render: (text) => text || "--" },
          // { title: '接收方', dataIndex: 'receiverName',width: 80, render: (text) => text || "--"},
          { title: '产品码', dataIndex: 'productCode', width: 240 ,render: (text) => text || "--" },
          { title: '产品名称', dataIndex: 'productName', width: 200 , render: (text) => text || "--" },
          { title: '产品数量', dataIndex: 'totalNum', width: 60 ,render: (text) => text || "--" },
          { title: '包装数量详情', dataIndex: 'specNumDetail', width: 200 , render: (text) => text || "--" },
        ],

      }
    },
    mounted(){

    },
    methods: {
        initShow(e){
            console.log(e,'======================e===============')
            this.sureVisible = true
            this.getOutProduct(e)
            // this.getProductCode(e)
        },
        async getOutProduct(e){
            this.searchId = e.id
            let params = {
                recordId : e.id,
                pageNo: this.ipagination.current,
                pageSize: this.ipagination.pageSize
            }
            const res = await getOutProductList(params)
            if (res.code == 200 && res.success == true) {
                console.log(res)
                this.$message.success(res.message)
                this.dataSource = res.result.records
                this.ipagination.total = res.result.total
            } else {
                this.$message.error(res.message)
            }
        },
        async handleTableChange(page,pageSize){
            this.ipagination.current = page.current
            this.ipagination.pageSize = page.pageSize
            let params = {
                recordId : this.searchId,
                pageNo: this.ipagination.current,
                pageSize: this.ipagination.pageSize
            }
            const res = await getOutProductList(params)
            if (res.code == 200 && res.success == true) {
                console.log(res)
                this.$message.success(res.message)
                this.dataSourceCode = res.result.records
                this.ipagination.total = res.result.total
            } else {
                this.$message.error(res.message)
            }
        },
        handleOk(){
            this.sureVisible = false
        },
        handleCancel(){
            this.sureVisible = false
        },
        modalFormOk(){
            this.loadData()
        },
        modalFormClose(){
            this.loadData()
        }
    }
}
</script>
<style lang="less" scoped>
    /deep/.ant-col {
        display: flex;
    }
    .basicTitle {
        display: block;
        font-size: 16x;
        margin: 0 0 30px;
        padding-left: 10px;
        border-left: 4px solid #1890FF;
    }
    .lisenceTitle {
        display: block;
        font-size: 16x;
        margin: 30px 0 30px;
        padding-left: 10px;
        border-left: 4px solid #1890FF;
    }
</style>
